
export default {
  label: '筛选项',
  labelSwitch: true,
  type: 'filter',
  property: '',
  value: ''
}